import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { style: {"position":"fixed","z-index":"99","width":"100vw"} }
const _hoisted_2 = {
  class: "hidden-md-and-up",
  "max-width": "100vw",
  width: "100vw"
}
const _hoisted_3 = { class: "d-flex flex-column align-center text-center w-100" }
const _hoisted_4 = { class: "d-flex justify-center mt-4 mb-8" }

import { computed, onMounted, onUnmounted, ref } from "vue";
import { useTheme } from "vuetify";
import { useStore } from "vuex";

// Komponenten-Imports
import LanguageSwitcher from "@/components/navigation/LanguageSwitcher.vue";
import ToggleTheme from "@/components/navigation/ToggleTheme.vue";

// Vuetify Theme + Store

export default /*@__PURE__*/_defineComponent({
  __name: 'TheNavigation',
  setup(__props) {

const theme = useTheme();
const store = useStore();

// Reaktive Daten
const views = ref([
  {
    tag_en: "Home",
    tag_de: "Start",
    to: { name: "Home" },
    icon: "home-outline",
  },
  {
    tag_en: "About",
    tag_de: "Über Mich",
    to: { name: "About" },
    icon: "information-outline",
  },
  {
    tag_en: "Experience",
    tag_de: "Erfahrung",
    to: { name: "Experience" },
    icon: "briefcase-outline",
  },
  {
    tag_en: "Projects",
    tag_de: "Projekte",
    to: { name: "Projects" },
    icon: "code-tags",
  },
]);

const mobileDialog = ref(false);
const dontShowAtTop = ref(false);
const tabsRef = ref<HTMLElement | null>(null);

// Theme 
const currentTheme = computed(() => theme.global.name.value);
const isDarkTheme = computed(() => currentTheme.value === "dark");

const themespecificLogoSrc = computed(() =>
  isDarkTheme.value
    ? new URL("@/assets/logo/dark/logo.svg", import.meta.url).href
    : new URL("@/assets/logo/light/logo.svg", import.meta.url).href
);

// Scrollverhalten
const onScroll = (e: Event) => {
  const top = window.pageYOffset || (e.target as HTMLElement)?.scrollTop || 0;
  dontShowAtTop.value = top > 600;
};

const dontShowAtTopComputed = computed(() =>
  dontShowAtTop.value ? "" : "text-white"
);

const isDE = computed(() => store.getters.isDE);

// Lifecycle
onMounted(() => {
  window.addEventListener("scroll", onScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", onScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _directive_scroll = _resolveDirective("scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_app_bar, {
      class: _normalizeClass(["appBar hidden-sm-and-down", !dontShowAtTop.value ? 'transparent-background' : '']),
      flat: "",
      elevation: "0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, {
          class: "shrink mr-2",
          alt: "Leo Giesen Logo",
          contain: "",
          width: "40",
          transition: "scale-transition",
          src: themespecificLogoSrc.value
        }, null, 8, ["src"]),
        _createVNode(_component_v_tabs, {
          "align-with-title": "",
          ref: "tabs"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(views.value, (view) => {
              return (_openBlock(), _createBlock(_component_v_tab, {
                key: view.to.name,
                to: view.to,
                class: _normalizeClass(dontShowAtTopComputed.value)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDE.value ? view.tag_de : view.tag_en), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            }), 128))
          ]),
          _: 1
        }, 512),
        _createVNode(_component_v_spacer),
        _createVNode(LanguageSwitcher, {
          class: _normalizeClass(dontShowAtTopComputed.value)
        }, null, 8, ["class"]),
        _createVNode(ToggleTheme, {
          class: _normalizeClass([dontShowAtTopComputed.value, "mr-5"])
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_app_bar, {
        class: "appBar d-flex justify-center align-center",
        flat: "",
        elevation: "0",
        height: "64",
        "max-width": "100vw",
        app: "",
        width: "100vw",
        style: {"position":"fixed","top":"0","left":"0","width":"100%","z-index":"10"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_spacer),
          _withDirectives(_createVNode(_component_v_app_bar_nav_icon, {
            class: "mr-5",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (mobileDialog.value = !mobileDialog.value), ["stop"]))
          }, null, 512), [
            [_vShow, !mobileDialog.value]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_overlay, {
        modelValue: mobileDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((mobileDialog).value = $event)),
        class: "appBar",
        scrim: true,
        persistent: "",
        style: {"z-index":"200"},
        "max-width": "100vw",
        width: "100vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, {
            class: "bg-background text-white d-flex flex-column align-center px-6 pt-6",
            elevation: "4",
            height: "100vh",
            width: "100vw",
            style: {"position":"relative"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "plain",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileDialog.value = false)),
                class: "position-absolute",
                style: {"top":"8px","right":"8px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "28" }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_img, {
                class: "mt-10 mb-8",
                src: themespecificLogoSrc.value,
                alt: "Leo Giesen Logo",
                contain: "",
                width: "70",
                "max-height": "70"
              }, null, 8, ["src"]),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(views.value, (view) => {
                  return (_openBlock(), _createBlock(_component_v_btn, {
                    key: view.to.name,
                    to: view.to,
                    variant: "text",
                    class: "my-3 text-uppercase",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileDialog.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        class: "me-2",
                        color: "secondary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-" + _toDisplayString(view.icon), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createTextVNode(" " + _toDisplayString(isDE.value ? view.tag_de : view.tag_en), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_divider, { class: "my-6 w-75" }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(LanguageSwitcher, {
                  class: "mx-6",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (mobileDialog.value = false))
                }),
                _createVNode(ToggleTheme, {
                  class: "mx-6",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (mobileDialog.value = false))
                })
              ]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ])), [
    [_directive_scroll, onScroll]
  ])
}
}

})